import { createFileRoute } from '@tanstack/react-router';
import { OperatingRulesDocument } from '@/pages/legacy-operating';

/**
 * Правила эксплуатации as a standalone, PUBLIC document — no shell, no auth
 * guard, no legacy-mode gate. The same text as `/delivery/operating`, for
 * linking or embedding outside the panel. Chromeless via `CHROMELESS_PATHS`.
 */
export const Route = createFileRoute('/operating-rules')({
  component: OperatingRulesDocument,
});
